import EmptyFeaturedProfiles from './EmptyFeaturedProfiles';
export default EmptyFeaturedProfiles;